<template>
  <div>
    <portal-target name="shPrintButton"></portal-target>
    <div :style="{ fontSize: fonts.font26 + 'px' }"
         class="head">{{ shareHead }}</div>

    <!-- Pending Transactions Box -->
    <div class="pCard" v-if="histPend.count > 0 && !printerFriendly">
      <div class="pbLine" style="height: 5px;"></div>
      <div class="pendBox" :style="{ fontSize: fonts.font12 + 'px' }">
        <div class="groupHeader">
          <span class="grHead" style="width: 20%">Date</span>
          <span class="grHead" style="width: 60%">Pending/Hold Items</span>
          <span class="grHead" style="width: 20%">Amount</span>
          <span class="grHead" style="width: 20%">Expiration</span>
        </div>
        <div v-for="pp in histPend.arr" :key="pp.key">
          <div :style="pp.selectBox">
            <div :style="pp.style" @click="toggleShare(pp)">
              <div class="groupSection"
                   :style="pp.highlight"
                   @mouseenter="mouseEnterP(pp)"
                   @mouseleave="mouseExitP(pp)">
                <div class="grCenter" style="width: 20%" v-html="pp.date2"></div>
                <div class="grPrime" style="width: 60%" v-html="pp.desc2"></div>
                <div class="grRight" style="width: 20%" v-html="pp.$amtBal"></div>
                <div class="grCenter" style="width: 20%" v-html="pp.remain"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pbLine" style="height: 5px;"></div>
    </div>

    <!-- Full Width Share Transaction -->
    <div v-if="fonts.percent >= 77 && !printerFriendly"
         class="bCard"
         :style="{ fontSize: fonts.font12 + 'px' }">
      <div class="groupHeader">
        <span class="clkHead" @click="clkDate" style="width: 14%">{{histShares.dateHeader}}</span>
        <span class="clkHead" @click="clkDesc" style="width: 44%">{{histShares.descHeader}}</span>
        <span class="clkHead" @click="clkWth" style="width: 14%">Withdrawal</span>
        <span class="clkHead" @click="clkDep" style="width: 14%">Deposit</span>
        <span class="grHead" style="width: 14%">Balance</span>
      </div>
      <div v-if="histShares.count < 0">
        Requesting Transactions from CU Server...
      </div>
      <div v-if="histShares.count === 0">
        No Transactions Found
      </div>
      <div v-if="histShares.count > 0"> <!-- [068] add this compare -->
        <div v-for="sh in histShares.arr" :key="sh.key">
          <div :style="sh.selectBox">
            <div :style="sh.style" @click="toggleShare(sh)">
              <div class="groupSection"
                   :style="sh.highlight"
                   @mouseenter="mouseEnter(sh)"
                   @mouseleave="mouseExit(sh)">
                <div class="grCenter" style="width: 14%" v-html="sh.date2"></div>
                <div class="grPrime" style="width: 44%" v-html="sh.desc2"></div>
                <div class="grRight" style="width: 14%">{{ sh.$db }}</div>
                <div class="grRight" style="width: 14%">{{ sh.$cr }}</div>
                <div class="grRight" style="width: 14%">{{ sh.$bal }}</div>
              </div>
            </div>
            <div v-show="sh.isActive">
              <div :style="sh.style">
                <b-button-group class="btnGroup">
                  <b-button v-show="sh.showDraftButton" class="btnDraft" @click="requestDraft(sh)">
                    Get Draft Image: {{sh.dft}}
                  </b-button>
                  <!-- <b-button v-show="sh.hasCard" class="btnCard" @click="requestCard(sh)">
                    Access Card Ending in: {{sh.card4}}
                  </b-button> -->
                  <!-- <b-button class="btnDetail" @click="historyDetail(sh)">
                    Request Details: {{sh.file}}-{{sh.tran}}
                  </b-button> -->
                </b-button-group>
                <div v-if="sh.explain === true" :style="{ fontSize: fonts.font18 + 'px' }">
                  {{sh.explainMessage}}
                </div>
              </div>
              <div v-if="sh.front === true || sh.back === true">
                <b-button-group class="btnGroup">
                  <b-button class="btnPrintDraft" @click="printDraft(sh)">
                    Print
                  </b-button>
                  <b-button class="btnCancel" @click="toggleShare(sh)">
                    close
                  </b-button>
                </b-button-group>
                <div :id="sh.imgBox">
                  <div :style="{ fontSize: fonts.font18 + 'px' }">{{sh.printHeader}}</div>
                  <b-img v-if="sh.front === true"
                         @click="toggleShare(sh)"
                         :src="sh.imgFront"
                         class="image">
                  </b-img>
                  <b-img v-if="sh.back === true"
                         @click="toggleShare(sh)"
                         :src="sh.imgBack"
                         class="image">
                  </b-img>
                </div>
              </div>
              <div v-if="sh.html === true" v-html="sh.htmlMessage">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Minimum Width Share Transaction -->
    <div v-if="fonts.percent < 77 && !printerFriendly"
         class="bCard" :style="{ fontSize: fonts.font12 + 'px' }">
      <div class="groupHeader">
        <span class="clkHead" @click="clkDate" style="width: 20%">{{histShares.dateHeader}}</span>
        <span class="clkHead" @click="clkDesc"  style="width: 60%">{{histShares.descHeader}}</span>
        <span class="clkHead" @click="clkWth"  style="width: 20%">Amt/Bal</span>
      </div>
      <div v-for="sh in histShares.arr" :key="sh.key">
        <div :style="sh.selectBox">
          <div :style="sh.style" @click="toggleShare(sh)">
            <div class="groupSection"
                 :style="sh.highlight"
                 @mouseenter="mouseEnter(sh)"
                 @mouseleave="mouseExit(sh)">
              <div class="grCenter" style="width: 20%" v-html="sh.date2"></div>
              <div class="grPrime" style="width: 60%" v-html="sh.desc2"></div>
              <div class="grRight" style="width: 20%" v-html="sh.$amtBal"></div>
            </div>
          </div>
          <div v-show="sh.isActive" :style="sh.style" >
            <b-button-group class="btnGroup">
              <b-button v-show="sh.showDraftButton" class="btnDraft" @click="requestDraft(sh)">
                Get Draft Image: {{sh.dft}}
              </b-button>
              <!-- <b-button v-show="sh.hasCard" class="btnCard" @click="requestCard(sh)">
                Access Card Ending in: {{sh.card4}}
              </b-button> -->
              <!-- <b-button class="btnDetail" @click="historyDetail(sh)">
                Request Details: {{sh.file}}-{{sh.tran}}
              </b-button> -->
            </b-button-group>
            <div v-if="sh.explain === true" :style="{ fontSize: fonts.font16 + 'px' }">
              {{sh.explainMessage}}
            </div>
            <div v-if="sh.front === true || sh.back === true">
              <b-button-group class="btnGroup">
                <b-button class="btnPrintDraft" @click="printDraft(sh)">
                  Print
                </b-button>
                <b-button class="btnCancel" @click="toggleShare(sh)">
                  close
                </b-button>
              </b-button-group>
              <div :id="sh.imgBox">
                <div :style="{ fontSize: fonts.font12 + 'px' }">{{sh.printHeader}}</div>
                <b-img v-if="sh.front === true"
                       @click="toggleShare(sh)"
                       :src="sh.imgFront"
                       class="image">
                </b-img>
                <b-img v-if="sh.back === true"
                       @click="toggleShare(sh)"
                       :src="sh.imgBack"
                       class="image">
                </b-img>
              </div>
            </div>
            <div v-if="sh.html === true" v-html="sh.htmlMessage">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="printerFriendly">
      <div id="shPrint">
        <div id="shPrintHeader">{{ shareHead }}</div>
        <table id="printTable">
          <thead>
          <tr>
            <th class="thItem" style="width: 12%">Date</th>
            <th class="thItem" style="width: 52%">Description</th>
            <th class="thItem" style="width: 12%">Withdrawal</th>
            <th class="thItem" style="width: 12%">Deposit</th>
            <th class="thItem" style="width: 12%">Balance</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="sh in histShares.arr" :key="sh.key">
            <td class="grCenter tdItem" v-html="sh.date2"></td>
            <td class="grPrime tdItem" v-html="sh.desc2"></td>
            <td class="grRight tdItem">{{ sh.$db }}</td>
            <td class="grRight tdItem">{{ sh.$cr }}</td>
            <td class="grRight tdItem">{{ sh.$bal }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <portal to="shPrintButton">
      <button id="btnShPrint"
              @click="togglePrinterFriendly">
        {{pfText}}
      </button>
      <!-- <button v-if="printerFriendly" class="btnPrintDraft" @click="printHistory">
        Print
      </button> -->
      <button
        id="btnPrintStmt"
        v-if="printerFriendly"
        class="btnPrintDraft"
        v-print="'#shPrint'">Print</button>
    </portal>
  </div>
</template>

<script>
// eslint-disable-next-line
import utl from '../myUtils';

export default {
  name: 'z-shareHistory',
  data() {
    return {
      rowHeight: 26,
      compact: false,
      updateCount: 0,
      printing: false,
      printerFriendly: false,
      pfText: 'Printer Friendly',
    };
  },
  watch: {
    HScc() {
      this.$forceUpdate();
    },
    HPcc() { // [153]
      this.$forceUpdate();
    },
  },
  computed: {
    HScc() {
      return this.$store.getters.getHScc;
    },
    HPcc() { // [153]
      return this.$store.getters.getHPcc;
    },
    history() {
      return this.$store.getters.getHistory;
    },
    histShares() {
      return this.$store.getters.getHistShares;
    },
    histPend() { // [153]
      return this.$store.getters.getHistPend;
    },
    pendTranCount() { // [153]
      return this.$store.getters.getPendTranCount;
    },
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    member() {
      return this.$store.getters.getMember;
    },
    shareHead() {
      return `${this.member.acct}-${this.history.desc}`;
    },
  },
  methods: {
    // eslint-disable-next-line
    toggleShare(sh) {
      const shInfo = {};
      shInfo.type = sh.type;
      shInfo.file = sh.file;
      shInfo.tran = sh.tran;
      shInfo.note = 0;
      shInfo.isActive = !sh.isActive;
      // sh.isActive = true;
      this.$store.commit('setActiveShareHistory', shInfo);
      this.$forceUpdate();
      let myShow = 'hide';
      if (sh.isActive) myShow = 'show';
      this.writeDiag(`toggleShare = ${sh.file}-${sh.tran} ${myShow}`);
      this.$store.commit('resetServerTimeout', shInfo);
    },
    printDraft(sh) {
      this.printing = true;
      this.$htmlToPaper(sh.imgBox);
    },
    printHistory() {
      this.$htmlToPaper('shPrint');
    },
    requestDraft(sh) {
      this.writeDiag(`Clicked Get Draft Image: ${sh.dft}`);
      const shInfo = {};
      shInfo.type = sh.type;
      shInfo.share = sh.share;
      shInfo.draft = sh.dft;
      shInfo.draftAcct = sh.draftAcct;
      shInfo.chkAct = sh.chkAct;
      shInfo.chkDgt = sh.chkDgt;
      shInfo.amt = sh.amt;
      shInfo.amt2 = sh.$amt;
      shInfo.date = sh.date;
      shInfo.time = sh.time;
      shInfo.item = sh.item;
      this.$store.commit('requestDraftImage', shInfo);
      this.$forceUpdate();
    },
    requestCard(sh) {
      this.writeDiag(`Clicked Get Card: ${sh.card}`);
      /*
      const shInfo = {};
      shInfo.type = sh.type;
      shInfo.share = sh.share;
      shInfo.draft = sh.dft;
      shInfo.draftAcct = sh.draftAcct;
      shInfo.date = sh.date;
      shInfo.time = sh.time;
      this.$store.commit('requestCard', shInfo);
      this.$forceUpdate(); */
    },

    // eslint-disable-next-line
    historyDetail(sh) {
      this.writeDiag(`Clicked Share history Detail # ${sh.key} ${sh.file}-${sh.tran}`);
      const shInfo = {};
      shInfo.type = sh.type;
      shInfo.file = sh.file;
      shInfo.tran = sh.tran;
      this.$store.commit('requestShareDetail', shInfo);
      this.$forceUpdate();
    },
    mouseEnter(sh) {
      // this.writeDiag(`Enter Share history Line # ${sh.key}`);
      if (!sh.isActive) {
        const shInfo = {};
        shInfo.key = sh.key;
        shInfo.style = 'background-color: green; color: white';
        this.$store.commit('setShareHistHighlight', shInfo);
      }
    },
    mouseExit(sh) {
      // this.writeDiag(`Exit Share history Line # ${sh.key}`);
      if (!sh.isActive) {
        const shInfo = {};
        shInfo.key = sh.key;
        shInfo.style = sh.style;
        this.$store.commit('setShareHistHighlight', shInfo);
      }
    },
    mouseEnterP(pp) {
      if (!pp.isActive) {
        const ppInfo = {};
        ppInfo.key = pp.key;
        ppInfo.style = 'background-color: green; color: white';
        this.$store.commit('setPendHistHighlight', ppInfo);
      }
    },
    mouseExitP(pp) {
      if (!pp.isActive) {
        const ppInfo = {};
        ppInfo.key = pp.key;
        ppInfo.style = pp.style;
        this.$store.commit('setPendHistHighlight', ppInfo);
      }
    },
    clkDate() {
      // utl.diag('Clicked Date Header');
      this.$store.commit('sortShareDate');
    },
    clkDesc() {
      // utl.diag('Clicked Description Header');
      this.$store.commit('sortShareDesc');
    },
    clkWth() {
      // utl.diag('Clicked Withdrawal Header');
      this.$store.commit('sortShareWth');
    },
    clkDep() {
      // utl.diag('Clicked Deposit Header');
      this.$store.commit('sortShareDep');
    },

    writeDiag(message) {
      this.$store.commit('putDiag', message);
    },
    togglePrinterFriendly() {
      this.printerFriendly = !this.printerFriendly;
      if (this.printerFriendly) {
        this.pfText = 'Interactive View';
      } else {
        this.pfText = 'Printer Friendly';
      }
    },
  },
};
</script>

<style scoped>
  .head {
    /* position: relative; */ /* setting this causes back-button to be ignored*/
    text-align: center;
    padding-right: 4px;
    z-index: 1;
    font-weight: bold;
    color: black;
    border: solid 1px black;
  }
  .bCard {
    padding: 4px;
    margin: 0px;
    width: 100%;
    border: solid 1px black;
  }
  .pCard {
    padding: 0px;
    margin: 0px;
    width: 100%;
    border: solid 1px black;
  }
  .pendBox {
    padding: 2px;
    margin: 0px;
    width: 100%;
    border: solid 2px red;
  }
  .pbLine {
    padding: 0px;
    margin: 0px;
    border: solid 3px red;
  }
  .btnCollapse {
    display: inline-block;
    padding: 0px;
    width: 100%;
    background-color: lightyellow;
    color: black;
    font-weight: bold;
  }
  .groupHeader {
    display: inline-flex;
    padding: 0px;
    width: 100%;
  }
  .groupSection {
    display: inline-flex;
    vertical-align: center;
    vert-align: middle;
    padding: 0px;
    width: 100%;
    /* height: 25px; */
    cursor: pointer;
  }
  .grHead {
    padding: 0px;
    /* height: 26px; */
    background-color: floralwhite;
    color: black;
    font-weight: bold;
    border: solid 1px black;
  }
  .clkHead {
    padding: 0px;
    /* height: 26px; */
    background-color: floralwhite;
    color: black;
    font-weight: bold;
    border: solid 1px black;
    cursor: pointer;
  }
  .grPrime {
    /* display: inline-flex; */
    text-align: left;
    padding: 0px 0px 0px 4px;
    background-color: transparent;
    font-weight: bold;
    /* text-decoration: underline; */
    border: dotted 1px lightgray;
  }
  .grLeft {
    text-wrap: avoid;
    text-align: left;
    padding: 0px 0px 0px 4px;
    background-color: transparent;
    font-weight: bold;
    border: dotted 1px lightgray;
  }
  .grCenter {
    text-wrap: avoid;
    text-align: center;
    padding: 0px;
    background-color: transparent;
    font-weight: bold;
    border: dotted 1px lightgray;
  }
  .grRight {
    text-align: right;
    padding: 0px 4px 0px 0px;
    background-color: transparent;
    font-weight: bold;
    border: dotted 1px lightgray;
  }
  .btnGroup {
    position: relative;
    display: inline-block;
  }
  .btnDraft {
    background-color: green;
    padding: 1px;
    margin: 4px;
    font-size: 12px;
    height: 20px;
  }
  .btnCard {
    background-color: green;
    padding: 1px;
    margin: 4px;
    font-size: 12px;
    height: 20px;
  }
  .btnDetail {
    background-color: green;
    padding: 1px;
    margin: 4px;
    font-size: 12px;
    height: 20px;
  }
  .image {
    position: relative;
    display: inline-flex;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    /* cursor: pointer; */
    /* border: solid 1px blue; */
  }
  .btnPrintDraft {
    background: lime;
    color: black;
    font-weight: bold;
  }
  .btnCancel {
    background-color: red;
    color: black;
  }
  #btnShPrint {
    background-color: lime;
    color: black;
    font-weight: bold;
  }
  #shPrint {
    width: 100%;
    border: solid 2px black;
    background: white;
    font-size: 20px;
    padding-bottom: 4px;
  }
  #shPrintHeader {
    font-size: 24px;
    font-weight: bold;
    color: black;
    padding: 8px;
    text-align: center;
  }
  #printTable {
    margin: auto;
  }
  .thItem {
    border: solid 1px black;
    background-color: lightgrey;
    font-weight: bold;
    color: black;
    padding: 4px;
    text-align: center;
  }
  .tdItem {
    border: solid 1px black;
    font-weight: bold;
    font-size: 16px;
    color: black;
    padding: 0px 4px; /* Padding TOP/BOTTOM = 0 / Padding Left/Right = 4 */
  }
</style>



// WEBPACK FOOTER //
// src/components/z-shareHistory.vue